module.exports = __webpack_public_path__ + "static/media/academicPlan.69c7eab7.svg";